<template>
  <div id="exhibitions">
    <div class="container">
      <div class="header-block">
        <InfoBlock :title="$getModuleTitle(currentEvent.modules, 'stands')" :desc="$t('stands.description')" :button="null" :url="null">
          <template slot="input">
            <div class="info-info">
              <el-row :gutter="16">
                <el-col :span="18">
                  <el-input v-model="filter.searchTerm" :placeholder="$t('search')" clearable @clear="filter.searchTerm = null"></el-input>
                </el-col>
                <el-col :span="6">
                  <el-select style="width:100%;" v-model="filter.saloonId" :placeholder="$t('filter')" class="w-100" @clear="filter.saloonId = null" clearable filterable>
                    <el-option v-for="item in currentBoothSaloons" :key="item.id" :label="item.title" :value="item.id"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </template>
        </InfoBlock>
      </div>

      <!-- <swiper class="category-wrapper" :options="swiperOption" v-if="currentBoothSaloons.length != 0">
        <swiper-slide class="category-box">
          <button class="category-item" @click="saloonId = null" :style="saloonId == null ? 'background-color :' + currentEvent.color + '; color: white;' : ''">
            <span>{{ $t("stands.all") }}</span>
          </button>
        </swiper-slide>

        <swiper-slide class="category-box" v-for="item in currentBoothSaloons" :key="item.id">
          <button @click="saloonId = item.id" class="category-item" :style="saloonId == item.id ? 'background-color :' + currentEvent.color + '; color: white;' : ''">
            <span> {{ item.title }} </span>
          </button>
        </swiper-slide>
      </swiper> -->

      <Nodata :title="$getModuleTitle(currentEvent.modules, 'stands')" :description="saloonId == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-expo-lottie" :loading="loading == 'getLoading'" v-if="currentBooths.length == 0" :button="$t('refresh')" @btnClick="refreshData" />

      <div class="exhibitions">
        <ExhibitionBlock :data="currentBooths" />
      </div>
      <div class="pagination-area" v-if="filter.total >= 15">
        <el-pagination background small @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="filter.take" layout="total, prev, pager,next" :total="filter.total"></el-pagination>
      </div>

      <!-- <infinite-loading @infinite="getData">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import $ from "jquery";
import axios from "axios";
import ExhibitionBlock from "../../modules/ExhibitionBlock";
import InfoBlock from "../../modules/InfoBlock";
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "Stands",
  components: { ExhibitionBlock, InfoBlock, InfiniteLoading },
  data() {
    return {
      filter: {
        skip: 0,
        take: 15,
        page: 1,
        total: 0,
        searchTerm: null,
        saloonId: null
      },
      saloonId: null,
      searchTerm: null,
      loading: false,
      timeout: null,
      swiperOption: {
        slidesPerView: "auto"
      }
    };
  },
  watch: {
    "filter.searchTerm": async function() {
      await this.searchFilter();
    },
    "filter.saloonId": async function() {
      await this.searchFilter();
    },
    "filter.page": async function() {
      await this.searchFilter();
    }
  },
  methods: {
    handleSizeChange(take) {
      this.filter.take = take;
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.filter.page = page;
    },
    async searchFilter() {
      this.loading = "getLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getBooths", {
          ...this.filter,
          id: this.currentEvent.id,
          route: false
        });
        this.filter.total = res.data.data.totalCount;
        if (res.data.data.items.length > 0) {
          this.loading = "booths";
        } else {
          this.loading = false;
        }
      }, 500);
    },
    async refreshData() {
      await this.$store.dispatch("getBooths", {
        ...this.filter,
        id: this.currentEvent.id,
        route: false
      });
      await this.$store.dispatch("getBoothSaloons", {
        id: this.currentEvent.id,
        route: false
      });

      this.loading = false;
      this.filter = {
        skip: 0,
        take: 15,
        page: 1,
        total: 0,
        searchTerm: null,
        saloonId: null
      };
      this.searchFilter();
    }
  },

  async mounted() {
    this.$nextTick(async () => {
      var res = await this.$store.dispatch("getBooths", {
        ...this.filter,
        id: this.currentEvent.id,
        route: false
      });
      this.filter.total = res.data.data.totalCount;
      await this.$store.dispatch("getBoothSaloons", {
        id: this.currentEvent.id,
        route: false
      });
    });
  },

  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentBooths() {
      return this.$store.getters.getBooths;
    },
    currentBoothSaloons() {
      return this.$store.getters.getBoothSaloons;
    }
  }
};
</script>

<style lang="less">
#exhibitions {
  .filterable-area {
    margin-bottom: 1rem;
  }
  background-color: #F1F3F6;


  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 20px;

  .container {
    display: block;
    max-width: 1120px;
    width: inherit;
    margin: 0 auto;
    margin-bottom: 40px;

    .category-wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;
      .category-box {
        .category-item {
          border: 0.5px solid#D6D9D9;
          background: #fff;
          padding: 8px 20px;
          border-radius: 30px;
          margin-right: 10px;
          cursor: pointer;
          font-family: "Roboto";
          color: #8c929c;

          span {
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
    }

    .exhibitions {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 16px;
      margin: 0px;
    }
  }
}
.category-box {
  width: auto !important;
  flex-shrink: auto;
}
@media (max-width: 768px) {
  #exhibitions {
    padding: 0px;
    padding-bottom: 60px;
    .container {
      padding: 0px 12px;
      .exhibitions {
        grid-template-columns: 1fr !important;
      }
    }
  }
}
.pagination-area {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/event/Stands.vue